export const EmployeeAbsenceApprovalStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  WITHDRAWN: 'WITHDRAWN',
};

export const EmployeeAbsenceApprovalStatusOption = [
  { value: EmployeeAbsenceApprovalStatus.PENDING, label: 'Szabadság igénylése', color: 'yellow' },
  { value: EmployeeAbsenceApprovalStatus.APPROVED, label: 'Engedélyezve', color: 'green' },
  { value: EmployeeAbsenceApprovalStatus.REJECTED, label: 'Elutasítva', color: 'red' },
  { value: EmployeeAbsenceApprovalStatus.WITHDRAWN, label: 'Visszavonva', color: 'blue' },
];
